<template>
  <div id="app">
    <nav class="navbar">
      <div class="nav-container">
        <h1 class="nav-title">提前还贷计算器</h1>
        <div class="nav-links">
          <router-link to="/" exact class="nav-link">计算器</router-link>
          <router-link to="/comparison" class="nav-link">方案对比</router-link>
        </div>
      </div>
    </nav>
    
    <main class="main-content">
      <router-view/>
    </main>
    
    <footer class="footer">
      <p>© 2025 房贷计算器 版权所有</p>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  background-color: #f5f5f5;
  line-height: 1.6;
}

#app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.navbar {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 1rem 0;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
}

.nav-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-title {
  font-size: 1.8em;
  font-weight: 300;
}

.nav-links {
  display: flex;
  gap: 20px;
}

.nav-link {
  color: white;
  text-decoration: none;
  padding: 8px 16px;
  border-radius: 5px;
  transition: background-color 0.3s;
}

.nav-link:hover,
.nav-link.router-link-exact-active {
  background-color: rgba(255,255,255,0.2);
}

.main-content {
  flex: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  width: 100%;
}

.footer {
  background: #333;
  color: white;
  text-align: center;
  padding: 20px;
  margin-top: auto;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .navbar {
    padding: 0.8rem 0;
  }
  
  .nav-container {
    flex-direction: column;
    gap: 12px;
    padding: 0 15px;
  }
  
  .nav-title {
    font-size: 1.5em;
    text-align: center;
  }
  
  .nav-links {
    gap: 8px;
    justify-content: center;
    flex-wrap: wrap;
  }
  
  .nav-link {
    padding: 8px 16px;
    font-size: 14px;
    border-radius: 20px;
    min-width: 80px;
    text-align: center;
  }
  
  .main-content {
    padding: 10px;
    flex: 1;
  }
  
  .footer {
    padding: 15px;
    font-size: 14px;
    margin-top: auto;
  }
}

/* 超小屏幕适配 */
@media (max-width: 480px) {
  .navbar {
    padding: 0.6rem 0;
  }
  
  .nav-container {
    padding: 0 10px;
    gap: 10px;
  }
  
  .nav-title {
    font-size: 1.3em;
  }
  
  .nav-links {
    gap: 6px;
  }
  
  .nav-link {
    padding: 6px 12px;
    font-size: 13px;
    min-width: 70px;
  }
  
  .main-content {
    padding: 5px;
  }
  
  .footer {
    padding: 12px;
    font-size: 13px;
    margin-top: auto;
  }
}
</style>
